// 查询菜单列表
export const AUTH_MENUS_LIST = '/cmms/auth/menus/list';

// 新增菜单或新增菜单子项
export const AUTH_MENUS_ADD = '/cmms/auth/menus/add';

// 编辑菜单或编辑菜单子项
export const AUTH_MENUS_EDIT = '/cmms/auth/menus/edit';

// 删除菜单
export const AUTH_MENUS_DELETE = '/cmms/auth/menus/delete';

// 查询字典项 列表
export const AUTH_DICTS_LIST = '/cmms/auth/dicts/list';

// 添加字典项到权限控制
export const AUTH_DICTS_SET_AUTH = '/cmms/auth/dicts/setAuth';

// 对字典项进行启用和禁用
export const AUTH_DICTS_SET_ENABLE = '/cmms/auth/dicts/setEnable';

// 区分系统账号和应用账号 列表
export const AUTH_GET_USER_LIST = '/cmms/newRole/getUserList';

// 新增账号接口修改
export const AUTH_USER_ADD_NEW = '/cmms/auth/user/addNew';

// 编辑账号接口修改
export const AUTH_USER_EDIT_NEW = '/cmms/auth/user/editUser';

// 查询角色列表接口修改
export const AUTH_TEAM_NEW_LIST = '/cmms/newRole/team/newList';

// 新增/编辑角色接口(新增)
export const AUTH_TEAM_ADD_NEW = '/cmms/newRole/team/add';
// 新增/编辑角色接口（编辑）
export const AUTH_TEAM_EDIT_NEW = '/cmms/newRole/team/edit';

// 角色用户延期
export const AUTH_ADD_EFFECTIVE_TIME = '/cmms/newRole/addEffectiveTime';

// 获取角色关联的用户列表
export const AUTH_NEW_ROLE_TEAM_USER_LIST = '/cmms/newRole/team/userList';

// 角色用户 新增用户
export const AUTH_NEW_ROLE_ADD_ACCOUNT_BATCH = '/cmms/newRole/addAccountBatch';

// 组织部门下拉框内容
export const AUTH_DEPT_GET_CAN_SELECT_ORG_DEPT = '/cmms/dept/getCanSelectOrgDept';

// 组织部门下拉框点击父部门的时候只获取下一层的部门
export const AUTH_DEPT_GET_SING_ORG_DEPT = '/cmms/dept/getSingOrgDept';

// 应用系统列表
export const AUTH_NEW_ROLE_GET_APP_LIST = '/cmms/newRole/getAppList';

// 查询角色下面的组织部门
export const AUTH_GET_TEAM_DEPT_BY_TEAM_ID = '/cmms/dept/getTeamDeptByTeamId';

// 查询角色下面的字典数据
export const AUTH_GET_TEAM_VALUE_BY_TEAM_ID = '/cmms/newRole/getTeamValueByTeamId';

// 查询角色下面的权限菜单和按钮
export const AUTH_GET_MENU_LIST_BY_TEAM_ID = '/cmms/newRole/getMenuListByTeamId';

// 获取角色下面的所有主体
export const AUTH_GET_ORGLIST_BY_TEAM_ID = '/cmms/api/getAccoutOrg';

// 获取独立应用菜单列表
export const AUTH_GET_MENUS_GET_APP_LIST = '/cmms/auth/menus/getAppList';
